<div class="cx-modal-container">
    <div class="cx-modal-content">
      <div class="cx-dialog-header modal-header">
        <div class="cx-dialog-title modal-title">
          <span class="title">{{
            'quoteCart.inventoryAvailability' | cxTranslate
          }}</span>
        </div>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="closeModal('close')"
        >
          <i class="material-icons">close</i>
        </button>
      </div>
      <div class="cx-dialog-body modal-body">
        <div class="row">
          <div class="cx-dialog-info col-md-12">
            <table class="inventory-table">
              <thead class="inventory-table headers">
                <tr>
                  <th>
                    <span>{{
                      'quoteCart.otherAvailableLocations' | cxTranslate
                    }}</span>
                  </th>
                  <th>
                    <span>{{ 'quoteCart.unitsAvailable' | cxTranslate }}</span>
                  </th>
                </tr>
              </thead>
              <tbody class="inventory-table body">
                <ng-container *ngFor="let entity of product">
                  <tr>
                    <td>
                      <span>{{ entity.name }}</span>
                    </td>
                    <td>
                      <span>{{
                        entity?.stockAvailable || 0 | number : '1.0-0'
                      }}</span>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="cx-dialog-info col-md-12">
            <div class="buy">
              <p class="buy-text">
                {{ 'quoteCart.buyFromAnotherSite' | cxTranslate }}
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="cx-dialog-info col-md-5 pr-0">
            <div class="inventory-text">
              <span>{{ 'quoteCart.changeAccountPara' | cxTranslate }}</span>
            </div>
          </div>
          <div class="cx-dialog-info col-md-2">
            <div><img src="../../../../../assets/img/orImg.svg" alt="OR" /></div>
          </div>
          <div class="cx-dialog-info col-md-5 pl-0">
            <div class="inventory-text">
              <span>{{ 'quoteCart.placeOrderPara' | cxTranslate }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="cx-dialog-footer modal-footer">
        <div class="row">
          <div class="col-sm-12 col-md-12 action-container">
            <button class="vs-primary-btn action-btn" (click)="closeModal('inv-avail-got-it')">
              <span>{{ 'quoteCart.gotIt' | cxTranslate }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  